import { languages } from '@/constant/language';
import { createSharedPathnamesNavigation } from 'next-intl/navigation';
import { routing } from './routing';

export const { Link, redirect, usePathname, useRouter } =
    createSharedPathnamesNavigation(routing);

export function extractLocaleFromPath(str: string) {
    let locale: undefined | string = undefined;
    if (str !== '/') {
        const split = str.split('/').filter((x) => x !== '');
        if (split.length > 0) {
            languages.forEach((x) => {
                if (split[0] === x) {
                    locale = split.shift();
                }
            });
        }
    }

    return locale;
}
